<template>
  <div>
    <router-link v-if="route != ''" tag="button" class="bm-button" :to="route">
        <slot></slot>
    </router-link>
    <a v-if="link != ''" :href="link">
        <button class="bm-button">
            <slot></slot>
        </button>
    </a>
    <button v-if="route == '' && link == ''" class="bm-button" @click="$emit('is-clicked')">
        <slot></slot>
    </button>
  </div>
</template>

<script>
export default {
    props: {
        type: {
            type: String,
            required: false,
            default: 'primary'
        },
        outlined: {
            type: Boolean,
            required: false,
            default: false
        },
        'is-inverted': {
            type: Boolean,
            required: false,
            default: false
        },
        route: {
            type: String,
            required: false,
            default: ''
        },
        link: {
            type: String,
            required: false,
            default: ''
        }
    }
}
</script>

<style lang="scss" scoped>
    .bm-button {
        border: none;
        border-radius: 100px;
        min-width: 100px;
        min-height: 35px;
        background-color: $primary;
        color: white;
        padding: 2px 20px;
        font-weight: bold;
        font-size: 14px;
    }
</style>